import { useLessonPlayer } from '../../hooks/useLessonPlayer.js'
import { FRAMES } from '../../model/frames.js'
import FocusLayout from './FocusLayout.jsx'

export default function FocusScreen({ frames = FRAMES } = {}) {
  const player = useLessonPlayer(frames)
  return <FocusLayout theme="dark" {...player} />
}
